module.exports = __webpack_public_path__ + "img/18000.bea653e0.jpg";